export const modalPages = {
  isModalOpen: false,
  activePageName: undefined,
  props: undefined,
};
